import { UserService } from "../../../../api/modules/userManagement/services/UserService";
import { MarketingMaterialService } from "../../../../api/modules/marketingMaterial/services/MarketingMaterialService";
import {MarketingMaterialItem} from "../../../../api/modules/marketingMaterial/models/MarketingMaterialItem";
import {StoreProxy} from "../../../../api/common/StoreProxy";
import {MimeTypeMapper} from "../../../../api/common/MimeTypeMapper";
import _ from 'lodash';
import Loading from 'vue-loading-overlay';

export default {
    name: "MarketingMaterialList",

    data() {
        return {
            _auth: '',
            isLoading: false,
            companyId: '',
            companies: [],
            items: [],
            showOrderSaveBtn: false
        }
    },
    components: {
        Loading
    },
    created(){

        this._auth = StoreProxy.getAuth(this.$store);
        let service = new UserService(StoreProxy.getAuth(this.$store), (e) => {
            console.error(e)
        });

        service.getCompanies().then(companies => {
                if (companies != null) {
                    this.companies = companies;
                }
            }
        ).catch(error => {
            this.$notify.error({
                title: 'Internal Error',
                message: 'Unable to retrieve companies list.'
            });
        });
    },
    methods:{
        getIconName(mimeType){
          return MimeTypeMapper.getIconType(mimeType);
        },
        getFileLabel(mimeType){
          return MimeTypeMapper.getLabelType(mimeType);
        },

        /**
         * Normalizes the sort order by assigning 1 to n+1 as sort order index to items in the list.
         * @param {any} items - array of marketing material items whose sort order should be normalized.
         */
        normalizeSortOrder(items) {
            if (items) {
                items.forEach((item, index) => {
                    if (item.orderIndex != index + 1) {
                        item.orderIndex = index;
                        item.orderIndex = index + 1;
                    }
                });
            }
        },

        /**
         * Determines whether there are sort order changes and updates state accordingly.
         */
        checkSortOrderChanges() {
            let hasChanges = false;
            this.items.forEach(i => {
                hasChanges = hasChanges || i.isOrderIndexChanged;
            });
            this.showOrderSaveBtn = hasChanges;
        },

        loadItems(companyId){

            let vm = this;
            MarketingMaterialItem.getItemsForCompany(StoreProxy.getAuth(this.$store), companyId).then(items => {
                vm.normalizeSortOrder(items);
                vm.items = items;
                vm.checkSortOrderChanges();
            }).catch(err => {

                if (!err) {
                    console.error(err);
                }

                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Unable to retrieve marketing material list.'
                });

            });
        },
        companySelected(companyId){
            this.loadItems(companyId);
            console.debug(`[d634559] company selected ${companyId}`);
        },
        companyClear(){
            this.items = [];
            this.companyId = '';
        },
        changeActiveStatus(item){
            if (item.isActive){
                this.deactivateItem(item);
            }
            else
            {
                this.activateItem(item);
            }
        },
        deactivateItem(item){
            if (!item){
                throw new Error('[e023617] marketing material item for deactivation is not an object!');
            }

            item.deactivate(this._auth).then(resolve => {
                this.$notify.success('Item successfully deactivated');
            }).catch(reject => {
                console.error('[e863078] Error deactivating item!');
                if (!reject){
                    console.error(reject);
                }
                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Failed to deactivate item. Please try again!.'
                });
            });
        },
        activateItem(item){
            item.activate(this._auth).then(resolve => {
                this.$notify.success('Item successfully activated!');
            }).catch(reject => {

                console.error('[e645750] Error activating item!');
                if (!reject){
                    console.error(reject);
                }

                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Failed to activate item. Please try again!.'
                });
            });
        },
        /**
         * Fires when the image order control changes.
         * @param {any} updatedItem - reference to the item whose order changed
         * @param {any} newIndex - new image index
         * @param {any} oldIndex - old image index
         * @returns true indicating to the control that the change is allowed
         */
        onOrderChanged(updatedItem, newIndex, oldIndex) {

            var vm = this;

            // Determine whether there are any ordering changes
            let hasOrderChanges = false;
            this.items.forEach(item => {
                if (item.isOrderIndexChanged) {
                    hasOrderChanges = true;
                }
            });

            // Make sure to show the save order button if there are changes
            this.showOrderSaveBtn = hasOrderChanges;

            // Swap indexes for the current item and whatever item matches its new index
            this.items.forEach(item => {
                if (item != updatedItem && item.orderIndex === newIndex) {
                    item.orderIndex = oldIndex;
                }
            });

            // Sort the images so they appear in the order the user has specified.
            // NOTE: for some reason swapping the index and then sorting the array
            // resulted in the UI showing the wrong index on the swapped item. It
            // seems to work if you let the index swap out and then "wait" before
            // running the sort.
            setTimeout(() => {
                vm.items.sort((a, b) => { return a.orderIndex - b.orderIndex });
            }, 250);

            return true;
        },
        onSaveOrder() {
            const toUpdate = [];
            const vm = this;

            // Normalize the sort order in case something weird happened with manaul index entry
            vm.normalizeSortOrder(this.items);

            // Iterate over all items looking for changes
            vm.items.forEach(item => {
                if (item.isOrderIndexChanged) {
                    toUpdate.push({
                        itemId: item.itemId,
                        sortIndex: item.orderIndex
                    });
                }
            });

            // Ensure we have items to update before calling the update API
            if (toUpdate.length > 0) {
                const service = new MarketingMaterialService(this._auth);


                /*service.setSortOrder2();*/
                let doIt = true;
                if (doIt) {
                    service.setSortOrder(toUpdate)
                        .then(ex => {
                            vm.showOrderSaveBtn = false;
                            vm.$notify.success({
                                title: "Sort Order Saved",
                                message: null
                            })
                        })
                        .catch(ex => {
                            vm.$notify.error({
                                title: 'Save Sort Order Failed',
                                message: 'One or more sort order indexes failed to save.  Please refresh page to reset item sort to actual state.'
                            });
                        });
                }
            }
        },
        downloadFile(item){
            if (!item){
                throw new Error('[e450885] marketing material item for download is not an object!' );
            }

            // check if file exists first.
            item.existsFile(this._auth).then(data => {
                if (data === true){
                    location.href = item.getDownloadUrl(this._auth);
                }
                else{
                    this.$alert('File not found in the server.\nPlease contact your administrator.', 'File Not Found', {
                        confirmButtonText: 'OK'
                    });
                }
            }).catch(err => {
                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Server error when checking for file!. Please contact support.'
                });
            });

        },
        deleteFile(item){
            if (!item){
                throw new Error('[e414253] marketing material item for deleting is not an object!' );

            }

            let vm = this;

            item.delete(this._auth).then(itemId => {

                console.log(itemId);
                _.remove(vm.items, function(tmpItem){
                    return tmpItem.itemId === itemId || tmpItem.itemId === '';
                });

                this.$notify.success('Item successfully deleted!');
            }).catch(error => {
                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Failed to delete item. Please try again!.'
                });
            });
        }

    }

}